import he from 'he';
import fp from 'lodash/fp';
import { connect } from 'react-redux';
import { compose, withHandlers, withProps } from 'recompose';
import { bindActionCreators } from 'redux';
import { businessActions, businessSelector, businessTeamsSelector } from '../../../../../state/modules/business';
import MultipleEntitiesTrainingPlans from '../partials/multi-entity-training-plans';

const mapStateToProps = (state) => ({
  business: businessSelector(state),
  businessTeams: businessTeamsSelector(state),
  isFetchingTeams: state.business.isFetchingTeams,
  taskStack: state.business.taskStack,
  setTrainingPlanSuccess: state.business.team.setTeamTrainingPlanSuccess
})

const mapDispatchToProps = (dispatch) => ({
  getTeams: bindActionCreators(businessActions.business.team.getTeams, dispatch),
  loadMoreTeams: bindActionCreators(businessActions.business.team.loadMoreTeams, dispatch),
  saveTeamTrainingPlan: bindActionCreators(businessActions.business.team.setTeamTrainingPlan, dispatch),
  initTaskStack: bindActionCreators(businessActions.business.initTaskStack, dispatch)
})

export const TeamsTrainingPlans = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    queryEntities: ({
      business,
      getTeams
    }) => (filter) => {
      getTeams(business.id, filter)
    },
    loadMoreEntities: ({
      business,
      loadMoreTeams
    }) => (filter) => {
      loadMoreTeams(business.id, filter)
    },
    saveCpdCategorys: ({
      business,
      saveTeamTrainingPlan
    }) => (trainingPlan, entity, currentUserId, industryId, industryEntity, goals) => {
      const planToSave = fp.map(
        plan => ({
          ...plan,
          businessTeamId: entity.id
        })
      )(trainingPlan)
      saveTeamTrainingPlan({
        cpdCategorys: planToSave,
        businessId: business.id,
        businessTeamId: entity.id,
        userId: currentUserId,
        industryId: industryId,
        industry: industryEntity,
        goals
      })
    }
  }),
  withProps(
    ({
      businessTeams,
      isFetchingTeams
    }) => ({
      entityTrainingPlans: fp.flow(
        fp.get('businessTeams'),
        fp.map(
          ({ team, cpdCategorys, industryBusinessTeam, goals }) => ({
            trainingPlan: cpdCategorys,
            entity: {
              ...team,
              name: he.decode(team.name)
            },
            goals: fp.map(
              ({ progressGoalId, points }) => ({
                goalId: progressGoalId,
                points
              })
            )(goals),
            industryEntity: fp.first(industryBusinessTeam)
          })
        )
      )(businessTeams),
      entityQueryResult: businessTeams,
      isFetchingEntities: isFetchingTeams
    })
  )
)(MultipleEntitiesTrainingPlans)




// WEBPACK FOOTER //
// ./src/containers/pages/app/account-settings/components/teams-training-plans.js